if (!customElements.get("modal-back-in-stock")) {
  customElements.define(
    "modal-back-in-stock",
    class BackInStock extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantRadios = this.querySelectorAll(".variant-radio");
        this.variantIdInput = this.querySelector(".product-variant-id");
        this.emailInput = this.querySelector(".email-input");
        this.submitButton = this.querySelector(".submit-svg");
        this.newsletterCheckbox = this.querySelector(".newsletter-checkbox");
        this.modal = document.querySelector("#Notification");
        this.soldOutModalWrap = document.querySelector(".sold-out-modal-wrap");
        this.mobileModal = document.querySelector("#MobileNotification");
        this.attachListeners();
        this.attachOutsideClickListener();
        this.init();
      }

      init() {
        if (this.classList.contains("modalDesktopView")) {
          const checkedRadio = this.querySelector(".variant-radio:checked");
          if (checkedRadio) {
            this.variantIdInput.value = checkedRadio.getAttribute("data-variant-id");
          }
        }
      }

      attachListeners() {
        this.variantRadios.forEach((radio) => {
          radio.addEventListener("change", this.handleVariantChange.bind(this));
        });
        this.emailInput.addEventListener("input", this.toggleSubmitButton.bind(this));
        this.form.addEventListener("submit", this.handleSubmit.bind(this));
        this.submitButton.addEventListener("click", this.handleSubmit.bind(this));
      }

      handleVariantChange(event) {
        this.variantRadios.forEach((radio) => {
          radio.checked = false;
          radio.nextElementSibling.classList.remove("checked");
        });

        event.target.checked = true;
        event.target.nextElementSibling.classList.add("checked");

        this.variantIdInput.value = event.target.getAttribute("data-variant-id");
      }

      toggleSubmitButton() {
        if (this.emailInput.value.length > 0 && this.emailInput.checkValidity()) {
          this.submitButton.removeAttribute("disabled");
        } else {
          this.submitButton.setAttribute("disabled", true);
        }
      }
      async handleSubmit(event) {
        event.preventDefault();

        const formData = {
          email: this.emailInput.value,
          variantId: this.variantIdInput.value,
          subscribeToNewsletter: this.newsletterCheckbox.checked,
        };

        const subscribeUrl = "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=YkVhdy";
        const manageUrl = "https://manage.kmail-lists.com/ajax/subscriptions/subscribe?a=YkVhdy&g=WPkqNw";

        const subscribeBody = JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ["EMAIL"],
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: formData.email,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${formData.variantId}`,
                },
              },
            },
          },
        });

        const completeText = '<div class="subscription__complete__text">We will let you know when your item is back in stock.</div>';
        const errorText = '<div class="subscription__error__text">There was an error with your subscription. Please try again later.</div>';

        const successCallback = () => {
          this.submitButton.insertAdjacentHTML("beforebegin", completeText);
          this.querySelector("fieldset").style.display = "none";
          // this.querySelector("#sold_out_email").style.display = "none";
          this.querySelector(".email-input").style.display = "none";
          this.querySelector(".sold-out-copy").style.display = "none";
          this.submitButton.textContent = "Submitted";
          this.submitButton.setAttribute("disabled", true);
        };

        const errorCallback = () => {
          this.submitButton.insertAdjacentHTML("beforebegin", errorText);
          this.querySelector("fieldset").style.display = "none";
          // this.querySelector("#sold_out_email").style.display = "none";
          this.querySelector(".email-input").style.display = "none";
          this.querySelector(".sold-out-copy").style.display = "none";
          this.submitButton.textContent = "Error!";
          this.submitButton.setAttribute("disabled", true);
        };

        const makeRequest = (url, data, headers, success, error) => {
          fetch(url, {
            method: "POST",
            headers: {
              ...headers,
            },
            body: data,
          })
            .then((response) => {
              if (response.ok || response.status == 200 || response.status == 202) {
                success();
              } else {
                return response.json().then(error);
              }
            })
            .catch((fetchError) => {
              console.error("Fetch error:", fetchError);
              error();
            });
        };

        makeRequest(
          subscribeUrl,
          subscribeBody,
          {
            accept: "application/json",
            revision: "2024-06-15",
            "content-type": "application/json",
          },
          successCallback,
          errorCallback
        );

        if (formData.subscribeToNewsletter) {
          const manageBody = JSON.stringify({ email: formData.email });
          makeRequest(manageUrl, manageBody, { "content-type": "application/json" }, successCallback, errorCallback);
        }
      }

      attachOutsideClickListener() {
        document.addEventListener("click", (event) => {
          if (this.modal) {
            if (this.modal.hasAttribute("open") && !this.modal.contains(event.target)) {
              this.closeModal(this.modal);
            }
          }

          if (this.mobileModal) {
            if (this.mobileModal.hasAttribute("open") && !this.mobileModal.contains(event.target)) {
              this.closeModal(this.mobileModal);
            }
          }
        });
      }
      closeModal(modal) {
        modal.removeAttribute("open");
      }
    }
  );
}
